<template>
  <!-- Left Column - Desktop -->
  <div class="flex flex-col gap-4 col-span-1">
    <div
      class="rounded-lg btn-bg-swap bg-btn-paper-primary py-[1.844rem] px-[.531rem] flex flex-col items-center"
    >
      <img
        :src="phx_logo"
        alt="PHX Logo"
        class="w-full h-[122px] object-contain [filter:drop-shadow(0_4px_50px_#fff)]"
      />

      <div class="py-6 text-center px-[5px]">
        <p class="font-inter font-medium text-stronger mb-2">Get the latest news</p>
        <h3 class="text-[28px] font-semibold leading-7 tracking-[-.56px] px-1 text-strongest">
          Subscribe to Our Newsletter!
        </h3>
      </div>
      <Button size="lg" variant="always-primary">
        <template #label>Sign up for our newsletter</template>
      </Button>
    </div>
    <div class="rounded-lg bg-container-bg p-6 flex flex-col">
      <h3 class="uppercase text-strong text-sm font-bold font-inter mb-[1.25rem]">Past Earnings</h3>
      <div class="flex flex-col gap-4 w-full">
        <a v-for="earnings in pastEarnings" :key="earnings.title" :href="earnings.link">
          <h4 class="text-sm font-semibold font-inter text-strongest">{{ earnings.title }}</h4>
          <p class="text-sm text-strong font-medium mt-1">
            {{ earnings.date.toLocaleDateString("en-US", { timeZone: "UTC" }) }}
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Button } from "@/components";

import phx_logo from "@/assets/images/newsfeed_phx_logo.png";

const pastEarnings = [
  { title: "Q1 2026 Earnings Reports", date: new Date("2026-03-01"), link: "#" },
  { title: "Q4 2025 Earnings Reports", date: new Date("2025-12-01"), link: "#" },
  { title: "Q3 2025 Earnings Reports", date: new Date("2025-09-01"), link: "#" },
  { title: "Q2 2025 Earnings Reports", date: new Date("2025-06-01"), link: "#" },
];
</script>
